var React = require('react');

function MenuClose (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M16.057 2.136 1.915 16.278.501 14.864 14.643.722z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M14.642 16.278.5 2.136 1.914.722l14.142 14.142z","key":1})]);
}

MenuClose.defaultProps = {"width":"17","height":"17","fill":"none"};

module.exports = MenuClose;

MenuClose.default = MenuClose;
